
import React, { useContext, useState, useRef, useEffect, useCallback, forwardRef, useImperativeHandle } from 'react';
import axios from 'axios';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { Notifications, Help, ArrowDropDown, Upload, UploadFileOutlined, CloseIcon, CloseRounded, } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Avatar,
  Button,
  Badge,
  Box,
  Select,
  Divider,
  Drawer,
  TextField,
  InputLabel,
  FormControl,
  FormControlLabel,
  Checkbox,
  InputAdornment,
  Paper, Tabs,
} from '@mui/material';

import Search from '@mui/icons-material/Search';
import Tab from '@mui/material/Tab';
import { formatDistanceToNow, parseISO } from "date-fns";
import {
    customerDataService,
    SearchTextFieldCustom,
    UtilityLibrary,
    LoggerUtility,
    SessionManager,
} from '../../../components/ComponentsLibrary';


const CustomerServiceContacts = forwardRef((props, ref) => {

    const {
        onComponentMount = () => { },
        PrimaryID,

    } = props;

    // Expose the method to the parent via ref
    useImperativeHandle(ref, () => ({
        onLoadCustomerServiceContactsByCaseID,
    }));

    useEffect(() => {
        if (onComponentMount) {
            onComponentMount();
        }
    }, []);

    const errorFormName = "Case Detail - Customer Service Contacts";
    const masterServerDBSchema = SessionManager.GetDataFromSession("SiteSettingsDetailsKey")?.masterDBSchema;
    const timeZone = SessionManager.GetDataFromSession("LoginUserInfoKey")?.timeZone;
    
    const caseDocsDataRefs = useRef([]); // Store DataGrid data persistently

    const contactSearchRef = useRef();

    const [isPageLoading, setIsPageLoading] = useState(false);

    const [searchText, setSearchText] = useState('');

    const [resultsCustomerServiceContacts, setResultsCustomerServiceContacts] = useState([]);
    const [paginationModel, setPaginationModel] = useState({ pageSize: 5, page: 0 });
    const [gridFilterModel, setGridFilterModel] = useState({ items: [] });

    const defaultPermissionsForFields = {
        clearFiltersBtn: { read: false, write: true, hide: false },
        exportDocumentsBtn: { read: false, write: true, hide: false },
        customerServiceContactsDgrd: { read: false, write: true, hide: false },
        documentViewerVwr: { read: false, write: true, hide: false },
        docVwr1Editor: { read: false, write: true, hide: false },
        docVwr1ToolbarItems: { read: false, write: true, hide: false },
        docVwr2Editor: { read: false, write: true, hide: false },
        docVwr2ToolbarItems: { read: false, write: true, hide: false },
        docVwrSplitBtn: { read: false, write: true, hide: false },
    }
    const [formFieldAccess, setFormFieldAccess] = useState(defaultPermissionsForFields);


    const customDateFormat = "MM/DD/YYYY hh:mm:ss A";

    // Grid Columns: Test Data Documents for a Case Number
    const customerServiceContactsGridColumns = [
        { field: 'related', headerName: 'Workflow Related', minWidth: 150, renderCell: (params) => params.value ? <span style={{ color: 'black', fontSize: '1.5em', height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>&#10003;</span>: null},
        { field: 'createdDate', headerName: 'Date', type: 'dateTime', valueFormatter: (value) => value && UtilityLibrary.formatDate(value, customDateFormat), minWidth: 200 },
        { field: 'contactID', headerName: 'Y-Trac Contact ID', valueFormatter: (value) => value === 0 ? '' : value, minWidth: 150 },
        { field: 'interactionID', headerName: 'NICE Contact ID', valueFormatter: (value) => value === 0 ? '' : value, minWidth: 150 },
        { field: 'contactChannel', headerName: 'Channel', minWidth: 100 },
        { field: 'role', headerName: 'Role', minWidth: 80 },
        { field: 'firstName', headerName: 'First Name', minWidth: 120 },
        { field: 'lastName', headerName: 'Last Name', minWidth: 120 },
        { field: 'categoryTypeName', headerName: 'Category', minWidth: 150 },
        { field: 'subCategoryTypeName', headerName: 'Sub-Category', minWidth: 180 },
        { field: 'action', headerName: 'Action', minWidth: 200 },
        { field: 'actionBy', headerName: 'Action By', minWidth: 120 },
        { field: 'tracNote', headerName: 'Trac Note', width: 90 },
        { field: 'narrative', headerName: 'Narrative', width: 90 },
    ];

    // Grid Columns: Test Data Documents for a Case Number
    const customerServiceContactsGridColumns04 = [
        { field: 'date', headerName: 'Date', flex: 1 },
        { field: 'contactID', headerName: 'Contact ID', valueFormatter: (value) => value === 0 ? '' : value, flex: 1 },
        { field: 'interactionID', headerName: 'Interaction ID', valueFormatter: (value) => value === 0 ? '' : value, flex: 1 },
        { field: 'channel', headerName: 'Channel', flex: 1 },
        { field: 'role', headerName: 'Role', flex: 1 },
        { field: 'firstName', headerName: 'First Name', flex: 1 },
        { field: 'lastName', headerName: 'Last Name', flex: 1 },
        { field: 'category', headerName: 'Category', flex: 1 },
        { field: 'subCategory', headerName: 'Sub-Category', flex: 1 },
        { field: 'action', headerName: 'Action', flex: 1 },
        { field: 'actionBy', headerName: 'Action By', flex: 1 },
        { field: 'yTracNote', headerName: 'Y-Trac Note', flex: 1 },
        { field: 'narrative', headerName: 'Narrative', flex: 1 },
    ];

    const customerServiceContactsGridRows = [
        { id: 1, date: '8/16/2024', contactID: '3952', interactionID: '', channel: 'Walk In',  role: 'CP', firstName: 'Kenisha', lastName: 'Green', category: 'General', subCategory: 'Questions about service', action: 'Referred-Interview Level 1', actionBy: 'Benjamin Winters', yTracNote: 'Question', narrative: 'Walk-In visitor received', },
        { id: 2, date: '7/28/2024', contactID: '3949', interactionID: '', channel: 'Walk In',  role: 'CP', firstName: 'Kenisha', lastName: 'Green', category: 'General', subCategory: 'Application for service', action: 'Referred-Interview Level 1', actionBy: 'Benjamin Winters', yTracNote: 'Application', narrative: 'Walk-In visitor received', },
        { id: 3, date: '4/08/2024', contactID: '3895', interactionID: '', channel: 'Call',  role: 'NCP', firstName: 'Craig', lastName: 'Washington', category: 'Employer', subCategory: 'General Information', action: 'Referred for Follow-Ups Case', actionBy: 'Lauren Peterman', yTracNote: 'General', narrative: 'NCP call regarding', },
        { id: 4, date: '7/12/2024', contactID: '3595', interactionID: '', channel: 'Walk In',  role: 'State', firstName: 'John', lastName: 'Smith', category: 'Medical Support', subCategory: 'Medical Support/OTE', action: 'Referred-Interview Level 2', actionBy: 'LienVi Lee', yTracNote: 'Medical', narrative: '', },
    ];




    //=======================================================================
    //  - Begin
    //=======================================================================

    const simulateAsyncDelay = async () => {
        await new Promise((resolve) => setTimeout(resolve, 0));
    }


    const onLoadCustomerServiceContactsByCaseID = async () => {
        try {
            const caseID = PrimaryID;
            const paramsObj = {
                caseNumber: caseID,
                activity_CustomerServiceID: null,
                masterServerDBSchema,
                systemTimeZoneName:timeZone
            };
            const csContactsApiData = await customerDataService.getCustServiceContactsFromApiByCaseID(paramsObj);
            // Make api call to fetch contactIDs and activityCustomerServiceIDs
            const paramsObjNoCase = {
                caseWorkflowID: 4613,//TODO set caseWorkflowID
                masterServerDBSchema,
            };
            const contactIdndAcsIdLst = await customerDataService.getEventsGridDataNoCaseFromApi(paramsObjNoCase);
            // Update data
            const updatedData = csContactsApiData.map((row,index) => {
                row.id = index + 1;
                row.related = contactIdndAcsIdLst.some(obj => (obj.contactID != null && obj.contactID === row.contactID &&
                   obj.activityCustomerServiceID != null && obj.activityCustomerServiceID === row.activityCustomerServiceID));
                return row;
            });
            setResultsCustomerServiceContacts(updatedData);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "onLoadCustomerServiceContactsByCaseID");
        }
    };

    
      // Function to handle search
      const handleSearchClick = async (event) => {
        setIsPageLoading(true);
        try {
          await simulateAsyncDelay();
          
        }
        catch (error) {
          await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleSearchClick");
        }
        finally { setIsPageLoading(false); }
      }; 

      const handleSearchChange = async (e) => {
          try {
            const {name, value} = e.target;
            setSearchText(value);
          }
          catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleSearchChange");
          }
        };
    
      // Function to handle clear of contact search value
      const handleSearchClear = async () => {
        setIsPageLoading(true);
        try {
          await simulateAsyncDelay();
          setSearchText('');
          
        }
        catch (error) {
          await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleSearchClear");
        }
        finally { setIsPageLoading(false); }
      };


    const handleGridFilterChange = async (newFilterModel) => {
        try {
            setGridFilterModel(newFilterModel);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleGridFilterChange");
        }
    };

    const handleGridClearFilters = async () => {
        try {
            setGridFilterModel({ items: [] });
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleGridClearFilters");
        }
    };



    //=======================================================================
    //  - End
    //=======================================================================


    //=======================================================================
    // Tabs Feature - Begin
    //=======================================================================


    //=======================================================================
    // Tabs Feature - End
    //=======================================================================



    const mainContactsContent = (
        <div style={{ padding: '10px 5px 5px', width: '100%' }}>            {
            resultsCustomerServiceContacts.length > 0 ? (
                <div>{/* Middle Section - Document Grid and Buttons  */}
                    <Paper elevation={2} className="document-grid" sx={{ boxShadow: "none" }}>
                        <div className="two-column-layout-container">
                            <div className="left-column-custom-1 text-wrapper-header-2" style={{ paddingLeft: '10px' }}>Customer Service Contacts:</div>
                        </div>
                        {!(formFieldAccess.customerServiceContactsDgrd?.hide ?? false) && (
                            <div style={{ display: "flex", flexDirection: "column", marginTop: '4px', height: "100%", width: "100%", overflowX: "auto" }}>
                                <DataGridPremium
                                    id="customerServiceContactsDgrd"
                                    name="customerServiceContactsDgrd"
                                    rows={resultsCustomerServiceContacts}
                                    columns={customerServiceContactsGridColumns}
                                    rowsPerPageOptions={[5]}
                                    pagination
                                    pageSizeOptions={[5, 10, 15, 20, 25]}
                                    paginationModel={paginationModel} // Controlled pagination
                                    onPaginationModelChange={setPaginationModel} // Handle page changes 
                                    filterModel={gridFilterModel}
                                    onFilterModelChange={handleGridFilterChange}
                                    autosizeOnMount
                                    autosizeOptions={{
                                        includeHeaders: true,
                                        includeOutliers: true,
                                        expand: true
                                    }}
                                    sx={{
                                        "& .MuiDataGrid-row:hover": {
                                          cursor: "pointer"
                                        },
                                        ".MuiTablePagination-displayedRows, .MuiTablePagination-selectLabel": {
                                          "margin-top": "1em",
                                          "margin-bottom": "1em"
                                        },
                                        "& .MuiDataGrid-virtualScroller": { overflowX: "auto", overflowY: "auto" }
                                      }}
                                />
                            </div>
                        )}
                    </Paper>
                </div>
            )
                :
                <div className="text-wrapper-subtitle">No Customer Service Contact found for the Case!</div>
        }
        </div>
    );



    return (
        <div style={{ height: '100%' }}>
            {mainContactsContent}
        </div>
    );
});

export default CustomerServiceContacts;


